module.exports = __webpack_public_path__ + "img/hr-roboport-shadow.0af331f4.png";